/**************************************************
 * Nombre:       Pagina_Personal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, IconButton, Typography} from "@mui/material";
import fondo from '../../../../Recursos/video_pagina.mp4'
import yt from '../../../../Recursos/ic_btn_youtube.svg'
import wass from '../../../../Recursos/ic_btn_wass.svg'
import logo from '../../../../Recursos/ic_btn_logo.svg'
import Boton_Icono from "./Boton_Icono";
import ic_you from '../../../../Recursos/ic_yt.svg'
import ic_face from '../../../../Recursos/ic_fac.svg'
import ic_insta from '../../../../Recursos/ic_insta.svg'
import ic_tik from '../../../../Recursos/ic_tic.svg'
import logoCompleto from '../../../../Recursos/logo_largo_claro.svg'
import {irUrl} from "../../../../Utilidades/irUrl";
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Pagina_Personal = ({item}) => {
    const {sCell} =useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 11}}>


            <video width={'100%'} height={750}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       // backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted
                // poster={cData.actColeccion.img}
            >

                <source src={fondo} type="video/mp4"/>

            </video>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    zIndex: 2,
                    m: 4,
                    mt: -90,
                    borderRadius: 4,
                    background: '#ffffff20',
                    backdropFilter: 'blur(3px)',
                    p: 4,
                    color: '#fff'
                }}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Avatar src={item.img} sx={{width: 110, height: 110, border: 5, borderColor: '#fff'}}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                    <Typography sx={{fontWeight: 600, fontSize: 16}}>{item.nombre + ' | ' + item.titulo}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <Typography sx={{fontWeight: 400, fontSize: 14, textAlign: 'center'}}>{item.frase}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Boton_Icono item={{
                        nombre: 'Presentación de negocio',
                        img: yt,
                        url: 'https://www.youtube.com/watch?v=nRsgmZpwvWY'
                    }}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Boton_Icono item={{
                        nombre: 'Agendar Reunion',
                        img: wass,
                        url: `https://api.whatsapp.com/send?phone=${item.celular}`
                    }}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Boton_Icono item={{
                        nombre: 'Testimonios de Clientes',
                        img: logo,
                        url: 'https://sistemateamtufino.com/Testimonios'
                    }}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Boton_Icono item={{nombre: 'Sistema Educactivo', img: logo, url: 'https://sistemateamtufino.com/'}}
                                 gradiente={true}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {item.youtube &&
                            <IconButton
                            onClick={() => irUrl(item.youtube)}
                            >
                                <img src={ic_you} width={28} height={'auto'}/>
                            </IconButton>
                        }

                        {item.facebook &&
                            <IconButton
                                onClick={() => irUrl(item.facebook)}
                            >
                                <img src={ic_face} width={28} height={'auto'}/>
                            </IconButton>
                        }

                        {item.instagram &&
                            <IconButton
                                onClick={() => irUrl(item.instagram)}
                            >
                                <img src={ic_insta} width={28} height={'auto'}/>
                            </IconButton>
                        }

                        {item.tiktok &&
                            <IconButton
                                onClick={() => irUrl(item.tiktok)}
                            >
                                <img src={ic_tik} width={28} height={'auto'}/>
                            </IconButton>
                        }

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                    <img src={logoCompleto} width={140} height={'auto'}/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Pagina_Personal    